import React from 'react';

import classes from './backdrop.css';

const backDrop=(props)=>(

    props.show? <div className={classes.BackDrop} onClick={props.clicked}></div>:null

);

export default backDrop;


// WEBPACK FOOTER //
// ./src/components/UI/backdrop/backdrop.js